<template>
  <div class="removeimg">
    {{ status }}
  </div>
</template>

<script>
import removeimg from 'api/removeimg'

export default {
  name: 'removeimg',
  data () {
    return {
      status: 'Please wait for remove files ...'
    }
  },
  created () {
    let tmpFolder = this.$route.params.folder
    let arrTmp = tmpFolder.split('-')
    let folder = typeof arrTmp[0] !== 'undefined' ? arrTmp[0] : ''
    let daydel = typeof arrTmp[arrTmp.length - 1] !== 'undefined' ? arrTmp[arrTmp.length - 1] : '365'
    let params = {
      folder: folder,
      daydel: daydel
    }
    removeimg.postRemoveImg(params)
        .then((response) => {
          this.status = 'Your Files are removed ( ' + response.data.response + ' ). !!!'
          console.log(response.data)
        })
        .catch((error) => {
          this.status = error
          console.log('Remove Files Error !!!', error)
        })
  }
}
</script>

<style lang="scss">
  .removeimg {
    text-align: center;
    font-size: 40px;
    color: #bbb;
    padding: 20% 20px;
    height: 100vh;
    vertical-align: middle;
  }
</style>


// WEBPACK FOOTER //
// component.vue?d8e21cd8